<template lang="pug">
include index.pug
</template>

<style lang="scss" scoped>
@import 'index';
</style>

<script>
export default {
  name: 'InputField',
  Inject: ['$validator'],
  props: {
    inputTextField: String,
    validationRules: {
      type: String,
      default: ''
    },
    inputType: {
      type: String,
      default: 'Text'
    },
    injectedValue: {
      type: String,
      default: ''
    },
    callback: Function,
    editable: {
      type: Boolean,
      default: true
    },
    ariaLabel: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      inputValue: '',
      validCallbackSent: false
    }
  },
  computed: {
    errorMessage: function () {
      return this.errors.first('inputfield') === null ? '-' : this.errors.first('inputfield')
    }
  },
  watch: {
    injectedValue: function () {
      this.inputValue = this.injectedValue
      this.validCallbackSent = true
    },
    inputValue: function () {
      if (this.errors.first('inputfield') === null && this.inputValue !== '' && this.callback) {
        this.callback({
          fieldName: this.inputTextField,
          value: this.inputValue,
          validationAccepted: this.inputValue !== ''
        })
      }
    },
    errorMessage: function () {
      if (this.callback) {
        if (this.errors.first('inputfield') === null && this.inputValue !== '') {
          this.callback({
            fieldName: this.inputTextField,
            value: this.inputValue,
            validationAccepted: this.inputValue !== ''
          })
          this.validCallbackSent = true
        } else if (this.validCallbackSent && this.errors.first('inputfield') !== null) {
          this.callback({
            fieldName: this.inputTextField,
            value: this.inputValue,
            validationAccepted: false
          })
          this.validCallbackSent = false
        }
      }
    }
  },
  mounted: function () {
    this.inputValue = this.injectedValue
  }
}
</script>
